import axios from "axios";

const server = process.env.REACT_APP_BACKEND

const api = axios.create({
  baseURL: server,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  }
});

/**
 * 取得所有啟用狀態的設定說明列表
 */
const GetInstructions = async () => {
  let response = await api.get("instructions");
  return response.data;
};

/**
 * 取得單一設定說明詳細資料
 * @param {number} instructionId 
 */
const GetInstructionById = async (instructionId) => {
  let response = await api.get(`instruction/${instructionId}`);
  return response.data;
};

/**
 * 新增設定說明手冊
 * @param {Object} instructionObj 
 * @param {string} instructionObj.title 說明標題
 * @param {string} [instructionObj.target_page_path] 跳轉頁面路徑
 * @param {Array<string>} [instructionObj.path_steps] 操作步驟陣列
 * @param {Array<Object>} [instructionObj.sections] 結構化內容區塊
 */
const CreateInstruction = async (instructionObj) => {
  let response = await api.post("instruction", instructionObj);
  return response.data;
};

/**
 * 編輯設定說明手冊
 * @param {number} instructionId 
 * @param {Object} instructionObj 包含要更新的欄位與內容
 */
const UpdateInstruction = async (instructionId, instructionObj) => {
  let response = await api.put(`instruction/${instructionId}`, instructionObj);
  return response.data;
};

/**
 * 刪除設定說明手冊
 * @param {number} instructionId
 */
const DeleteInstruction = async (instructionId) => {
  let response = await api.delete(`instruction/${instructionId}`);
  return response.data;
};

/**
 * 獲取手冊PDF
 */
const DownloadInstructionPDF = async (filename) => {
  let response = await api.get(`instruction/${filename}`, {
    responseType: 'blob',
  });
  return response.data;
}


export {
  GetInstructions,
  GetInstructionById,
  CreateInstruction,
  UpdateInstruction,
  DeleteInstruction,
  DownloadInstructionPDF,
};